import { Artist, ArtistRegisterStatus } from '@favid-inc/api';
// import { Put } from '@favid-inc/api/lib/rest';
import { Action } from 'core/generic';
import { Modal } from 'core/modal';
import { updateArtist } from 'features/artist';
import React from 'react';
// import { request as client } from 'utils';
// import { actionRequest } from 'utils/request';
import { SubAcount } from './SubAccountForm';

interface Props {
  artist: Artist;
  onUpdateArtist?: (action: Action) => void;
  onClose: () => void;
}
class SubAccountComponent extends React.Component<Props> {
  onClose = () => {
    this.props.onClose();
  };

  onSubmitForm = async (formValues: SubAcount) => {
    // if (onUpdateArtist) {
    //   try {
    //     const request: ApproveArtistRegister['Request'] = {
    //       url: '/ApproveArtistRegister',
    //       method: 'POST',
    //       data: {
    //         artist: this.props.artist,
    //       },
    //     };
    //     await actionRequest.request<ApproveArtistRegister['Response']>(request);
    //     updateArtist(artist, onUpdateArtist);
    //   } catch (error) {}
    // }
  };

  onConfirmApprove = async () => {
    const { artist, onUpdateArtist } = this.props;
    artist.registerStatus = ArtistRegisterStatus.APPROVED;
    if (onUpdateArtist) {
      updateArtist(artist, onUpdateArtist);
    }
    this.onClose();
  };

  renderActionButtons() {
    return (
      <React.Fragment>
        <div className='ui button' onClick={this.onClose}>
          Cancelar
        </div>
        <div className='ui button primary' onClick={this.onConfirmApprove}>
          Confirmar
        </div>
      </React.Fragment>
    );
  }

  renderContent() {
    return <div>Confirmação de aprovação de cadastro</div>;
    // return <SubAccountForm onSubmit={this.onSubmitForm} actionButtons={this.renderActionButtons()} />;
  }

  render() {
    return (
      <Modal
        header='Dados da conta iugo'
        handleClose={this.onClose}
        content={this.renderContent()}
        actions={this.renderActionButtons()}
        isOpen={true}
      />
    );
  }
}
export const SubAccount = SubAccountComponent;
